// extracted by mini-css-extract-plugin
module.exports = {"button":"GoToBackButton_button__5nBeD"};